// extracted by mini-css-extract-plugin
export default {"gcMap":"LeafletMap_gcMap__Pug54"};